import { RESOURCE_NAME } from '@esentai/core/features/parkingWhitelistFilter/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadWhitelistFilter = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateWhitelistFilter = authorizeIf(canCreate(RESOURCE_NAME));
export const canUpdateWhitelist = authorizeIf(canUpdate(RESOURCE_NAME));
